import React from 'react';
import PropTypes from 'prop-types';

import Anchor from '../form/form-anchor'

import './contact-chips.styl'
class ContactChips extends React.Component {
    static propTypes = {
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        '@image': PropTypes.string.isRequired,
        '@profile': PropTypes.string.isRequired,
        'onClick': PropTypes.func
    }

    static defaultProps = {
        onClick: console.log
    }

    fullname = this.props.firstName + ' ' + this.props.lastName.toUpperCase()

    render() {
        return <li className="contactChips" onClick={this.props.onClick}>
            <img src={this.props['@image']} />
            <Anchor href={this.props['@profile']} label={this.fullname} />
        </li>
    }
}

export default ContactChips;
